function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $uniUP } from "../..";
export var DialogFormProxy = /*#__PURE__*/function () {
  function DialogFormProxy(opts) {
    _classCallCheck(this, DialogFormProxy);
    this.activo = false;
    opts && opts.title && (this.title = opts.title);
  }
  return _createClass(DialogFormProxy, [{
    key: "open",
    value: function open() {
      for (var _len = arguments.length, opts = new Array(_len), _key = 0; _key < _len; _key++) {
        opts[_key] = arguments[_key];
      }
      this.args = opts;
      this.activo = true;
    }
  }, {
    key: "close",
    value: function close() {
      this.activo = false;
    }
  }]);
}();

/*
    class DialogFormFactory {
        // new: (opts?: any) => DialogForm

        constructor(opts?: any) {
            
        }

        new(opts?: any) {
            return function (opts) {
                return new DialogFormProxy(this.$http, this.$log, this.UniConfig, opts);
            }
        }
    }
    */

$uniUP.factory("DialogFormFactory", function () {
  return function (opts) {
    return new DialogFormProxy(opts);
  };
})

// para instanciar up.DialogFormProxy necesario para extender en unitec
;
(window.up = window.up || {}).DialogFormProxy = DialogFormProxy;